import React from "react";
import { FastField } from "formik";

import { NumberField } from "../../../../../../elements/FormField";
import { numberValidator } from "../../../../../../utils/formValidators";

const ContentDensity = ({ prefix }) => (
  <FastField
    component={NumberField}
    name={`${prefix}.contentDensity`}
    validate={numberValidator({ min: 0, max: 100000 })}
    min={0}
    max={100000}
  />
);

export default ContentDensity;
